import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import { TicketTypeSerializer } from "@shared/modules/events/types/public";
import { isMultiDayEvent } from "@shared/modules/events/utils/event-utils";
import Box from "@ui-kit/layout/Box/Box.web";
import useItemGroupEvent from "../hooks/useItemGroupEvent";
import type { BaseItemGroupDisplayProps } from "../ItemGroup.props";
import ItemGroupDisplay from "../ItemGroupDisplay/ItemGroupDisplay.web";
import ItemGroupSkeleton from "../ItemGroupSkeleton/ItemGroupSkeleton.web";

export default function ItemGroupEvent({
  eventId,
  quantity,
  ticketTypeId,
  isParentLoading = false,
  updateItemTracking,
  eventService,
  allowQuantityChange = true,
  ...rest
}: {
  eventId: number;
  quantity: number;
  ticketTypeId: number | undefined;
  updateItemTracking: ((input: GtagItemType) => void) | undefined;
  isParentLoading: boolean | undefined;
  allowQuantityChange?: boolean | undefined;
} & Omit<BaseItemGroupDisplayProps, "name">): JSX.Element {
  const { eventData, ticketTypes, isFetching } = useItemGroupEvent(
    eventId,
    ticketTypeId,
    eventService,
    updateItemTracking,
    rest.id
  );
  const showSkeleton = isFetching || isParentLoading;
  const ticketType = (ticketTypes as TicketTypeSerializer[])?.find(
    (ticketType) => ticketType.id === ticketTypeId
  );

  const shippingTypes = ticketType?.shipping_type;

  return (
    <Box width="100%">
      {showSkeleton && <ItemGroupEvent.Skeleton />}
      {!showSkeleton && eventData && (
        <ItemGroupDisplay
          eventService={eventService}
          {...rest}
          startsOn={eventData.starts_on}
          allowQuantityChange={allowQuantityChange}
          endsOn={eventData.ends_on}
          isMultiDayEvent={isMultiDayEvent(eventData)}
          name={eventData.name || ""}
          subtitle={ticketType?.name}
          quantity={quantity}
          timezone={eventData.timezone}
          minQuantity={ticketType?.minimum_purchase_limit}
          maxQuantity={ticketType?.purchase_limit}
          shippingTypes={shippingTypes}
        />
      )}
    </Box>
  );
}

ItemGroupEvent.Skeleton = ItemGroupSkeleton;
